// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".separate-fileselect-modal-header[data-v-fce1e92e]{width:100%}.separate-fileselect-modal-header .title[data-v-fce1e92e]{font-size:22px}.separate-fileselect-modal-header .message[data-v-fce1e92e]{color:#d94a7d;font-size:16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
